import * as Yup from "yup";

export const FormAddUserScheme = () => {
  return Yup.object().shape({
    username: Yup.string()
      .trim()
      .required("El campo es requerido"),
    password: Yup.string()
      .trim()
      .required("El campo es requerido"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password")], "Las contraseñas no coinciden")
      .required("Confirma tu contraseña"),
    role: Yup.string()
      .oneOf(["user", "admin"], "Rol inválido")
      .required("El campo es requerido")
      .default("user")
  });
};
